import Sidebar from './Sidebar.js';
import "bootstrap/dist/css/bootstrap.min.css";

import { Chart as ChartJS } from 'chart.js/auto';
import { Bar,Doughnut,Line } from 'react-chartjs-2'

import { useEffect,useState } from 'react';

function Dashboard() {

    const [monthOrder,setMonthOrder] = useState([0,0,0,0,0,0,0,0,0,0,0,0]); 
    const [coffeeOrder,setCoffeeOrder] = useState([0,0,0,0,0]);

    const [totalPrice,setTotalPrice] = useState([0,0,0,0,0,0,0,0,0,0,0,0]);
    const [totalCost,setTotalCost] = useState([0,0,0,0,0,0,0,0,0,0,0,0]);

    const [totalProfit, setTotalProfit] = useState([0,0,0,0,0,0,0,0,0,0,0,0]);

    const [loading,setLoading] = useState(true);

    useEffect(()=>{
        loadFunc();
    },[])

    const loadFunc = async() => {
    
        const dataToPass = {
            method: 'GET',
            headers: { 'Content-Type':'application/json' },
        }

        const dataToPass2 = {
            method: 'GET',
            headers: { 'Content-Type':'application/json' },
        }

        try {
            const resp = await fetch("https://cfryapi.onrender.com/getAllMonth",dataToPass).then(resp=>resp.json())
            const resp2 = await fetch("https://cfryapi.onrender.com/getMenu",dataToPass2).then(resp=>resp.json())

            const menuData = []

            resp2.forEach(e=>
                menuData.push(e)
            )
    
            const monthOrderTemp = [0,0,0,0,0,0,0,0,0,0,0,0]
            const coffeeOrderTemp = [0,0,0,0,0]

            const priceTemp = [0,0,0,0,0,0,0,0,0,0,0,0]
            const costTemp = [0,0,0,0,0,0,0,0,0,0,0,0]

            resp.forEach(e=>
                monthOrderTemp[parseInt(e.month)-1] = e.order.reduce((partialSum, a) => partialSum + a, 0),
            )

            resp.forEach(e=> coffeeOrderTemp[0] += e.order[0])
            resp.forEach(e=> coffeeOrderTemp[1] += e.order[1])
            resp.forEach(e=> coffeeOrderTemp[2] += e.order[2])
            resp.forEach(e=> coffeeOrderTemp[3] += e.order[3])
            resp.forEach(e=> coffeeOrderTemp[4] += e.order[4])

            resp.forEach(e=>
                priceTemp[parseInt(e.month)-1] = e.order[0] * menuData[0].price + e.order[1] * menuData[1].price + e.order[2] * menuData[2].price + e.order[3] * menuData[3].price + e.order[4] * menuData[4].price
            )

            resp.forEach(e=>
                costTemp[parseInt(e.month)-1] = e.order[0] * menuData[0].cost + e.order[1] * menuData[1].cost + e.order[2] * menuData[2].cost + e.order[3] * menuData[3].cost + e.order[4] * menuData[4].cost
            )

            const profitTemp = []

            priceTemp.forEach((e,i)=>
                profitTemp.push(e-costTemp[i])
            )

            setMonthOrder(monthOrderTemp)
            setCoffeeOrder(coffeeOrderTemp)

            setTotalPrice(priceTemp)
            setTotalCost(costTemp)
            setTotalProfit(profitTemp)

            setLoading(false)

        } catch (error) {
            console.log(error)
        }
    }

    if(loading){
        return <div>Loading data, Please wait 20 seconds</div>
    }

    return (
        <div className='row'>
            <div className='col-2'>
                <Sidebar selected={'Dashboard'}/>
            </div>
            <div className="col-10 container d-flex flex-column">
                <div className="row pt-4">
                    <div className='col-5 sqr'>
                        <div>
                            <Line
                                data= {{
                                    labels: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
                                    datasets: [
                                        {
                                        label: 'Profits',
                                        data: totalProfit,
                                        borderColor: '#3e1e04b0',
                                        backgroundColor: '#3e1e04b0',
                                        borderWidth: 2
                                        },
                                        {
                                        label: 'Gross Income',
                                        data: totalPrice,
                                        borderColor: '#c4923eb0',
                                        backgroundColor: '#c4923eb0',
                                        borderWidth: 2
                                        }
                                    ],
                                }}

                                options={{
                                    plugins: {
                                        legend: {
                                          display: true,
                                          position: 'bottom'
                                        },
                                        title: {
                                            display: true,
                                            text: 'Profit and Gross Income',
                                          }
                                      }
                                }}
                                
                            />
                        </div>
                    </div>
                    <div className='col-5 sqr mx-4'>
                        <div>
                        <Line
                                data= {{
                                    labels: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
                                    datasets: [
                                        {
                                        label: 'Cost',
                                        data: totalCost,
                                        borderColor: '#3e1e04b0',
                                        backgroundColor: '#3e1e04b0',
                                        borderWidth: 2
                                        },
                                        {
                                        label: 'Gross Income',
                                        data: totalPrice,
                                        borderColor: '#c4923eb0',
                                        backgroundColor: '#c4923eb0',
                                        borderWidth: 2
                                        }
                                    ],
                                }}

                                options={{
                                    plugins: {
                                        legend: {
                                          display: true,
                                          position: 'bottom'
                                        },
                                        title: {
                                            display: true,
                                            text: 'Cost and Gross Income',
                                          }
                                      }
                                }}
                                
                            />
                        </div>
                    </div>
                </div>
                <div className="row pt-4">
                    <div className='col-3 sqr'>
                        <div>
                            <Doughnut
                                data= {{
                                    label: "test",
                                    labels: ['Cappucino','Latte', 'Affogato','Americano', 'Espresso'],
                                    datasets: [
                                        {
                                        label: 'Total Orders',
                                        data: coffeeOrder,
                                        backgroundColor: ['#cbac85','#c4923e','#965015','#6a3005','#3e1e04'],
                                    }
                                    ],
                                }}

                                options={{
                                    plugins: {
                                        legend: {
                                          display: true,
                                          position: 'bottom'
                                        },
                                        title: {
                                            display: true,
                                            text: 'Total Orders per Coffee Type'
                                          }
                                      }
                                }}
                            />
                        </div>
                    </div>
                    <div className='col-7 sqr mx-4'>
                        <Bar
                            data= {{
                                labels: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
                                datasets: [
                                    {
                                    label: 'Monthly Orders',
                                    data: monthOrder,
                                    backgroundColor: '#c4923eb0'
                                    }
                                ],
                                
                            }}

                            options={{
                                plugins: {
                                    legend: {
                                        display: false,
                                        position: 'bottom'
                                    },
                                    title: {
                                        display: true,
                                        text: 'Number of Orders each Month',
                                        }
                                    }
                            }} 
                        />
                    </div>
                </div>
            </div>
            <div className='col-10 pt-4'>
                
            </div>
        </div>
    );
  }
  
export default Dashboard;